'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * https://stackoverflow.com/questions/27706594/how-can-i-make-recaptcha-a-required-field
 */

define([], function () {
  var Captcha = function () {
    function Captcha() {
      _classCallCheck(this, Captcha);
    }

    _createClass(Captcha, [{
      key: 'init',
      value: function init(element) {
        var self = this;
        this.element = element;
        var recaptcha = element.querySelector('#g-recaptcha-response');
        if (recaptcha) {
          recaptcha.setAttribute('required', 'required');
        }

        // Prevent the user from tabbing to this element
        var recaptchaResponse = document.getElementById('g-recaptcha-response');
        recaptchaResponse.setAttribute('aria-hidden', 'true');
        recaptchaResponse.setAttribute('tabindex', '-1');

        recaptchaResponse.addEventListener('focus', function () {
          self.getNextFocusableElement(recaptchaResponse).focus();
        });
      }
    }, {
      key: 'getNextFocusableElement',
      value: function getNextFocusableElement(el) {
        var focusableEls = document.querySelectorAll('a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        var list = Array.prototype.slice.call(focusableEls).filter(function (el) {
          return el.offsetParent;
        }); // Remove hidden elements
        var index = list.indexOf(el);
        return list[index + 1] || list[0];
      }
    }]);

    return Captcha;
  }();

  return Captcha;
});
//# sourceMappingURL=captcha.js.map
